import React, { useEffect, useState } from "react";
import useHttp from '../../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData from '../../../Dashboard/Driveanalysis/NoData';
import ChartLoader from '../../../Dashboard/Driveanalysis/ChartLoader';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../../Dashboard/DashboardMain/WaterMark";

function RealWorldBar_Orion({ apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const appyData = (data) => {
    const res_result = data;
    let responce =
    {
      "<100": { per: 0, count: 0 },
      "150": { per: 0, count: 0 },
      "200": { per: 0, count: 0 },
      "250": { per: 0, count: 0 },
      "300": { per: 0, count: 0 },
      ">300": { per: 0, count: 0 },
    };

    if (res_result.length != 0) {
      let t_val = res_result[0];
      if (t_val.doc_count != 0) {
        if (t_val.less_100.value > 0) {
          responce["<100"] = { per: parseInt((t_val.less_100.value / t_val.doc_count) * 100), count: parseInt(t_val.less_100.value) };
        }
        if (t_val.B100_150.value > 0) {
          responce["150"] = { per: parseInt((t_val.B100_150.value / t_val.doc_count) * 100), count: parseInt(t_val.B100_150.value) };
        }
        if (t_val.B150_200.value > 0) {
          responce["200"] = { per: parseInt((t_val.B150_200.value / t_val.doc_count) * 100), count: parseInt(t_val.B150_200.value) };
        }
        if (t_val.B200_250.value > 0) {
          responce["250"] = { per: parseInt((t_val.B200_250.value / t_val.doc_count) * 100), count: parseInt(t_val.B200_250.value) };
        }
        if (t_val.B200_250.value > 0) {
          responce["300"] = { per: parseInt((t_val.B200_250.value / t_val.doc_count) * 100), count: parseInt(t_val.B200_250.value) };
        }
        if (t_val.greater_300.value > 0) {
          responce[">300"] = { per: parseInt((t_val.greater_300.value / t_val.doc_count) * 100), count: parseInt(t_val.greater_300.value) };
        }

        let res_result_final = [["Element", "percent", { type: 'string', role: "tooltip", 'p': { 'html': true } }, { role: "style" }]]

        let loop_keys = Object.keys(responce);
        loop_keys = ["<100", "150", "200", "250", "300", ">300"]

        loop_keys.map(x => {
          res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "stroke-width: 1;stroke-color: black;"]);
          // res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span></div>", "stroke-width: 1;stroke-color: black;"]);
        })
        setChartData((prestate) => res_result_final);
      } else {
        setChartData((prestate) => []);
      }
    }
  }


  const options = {
    hAxis: {
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
      ,
      gridlines: {
        color: 'transparent'
      },
      title: 'Range',
      minValue: 0,
      format: 'short',
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Discharge Cycles',
      // title: 'Discharge Count',
      minValue: 0,
      format: '#\'%\'',
      // format: '#\'',
    },
    bar: { groupWidth: "100%" },
    tooltip: { isHtml: true },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  return (
    <>
      <div className=" p-2">
        <div className="v-title">
          <div className="chartHGT">
            <WaterMark />
            {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} />)}
          </div>
        </div>
      </div>
    </>
  );
}

export default RealWorldBar_Orion;
